export default __webpack_public_path__ + "static/1823-e0e61dc4e393122866451eefa557a165.gif";